import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    resultBannerListLoading: false,
    resultBannerList: {},
    resultBannerListError: null,
    resultBannerDetailsLoading: false,
    resultBannerDetails: {},
    resultBannerDetailsError: "",
    resultBannerByIdLoading: false,
    resultBannerByIdSuccess: {},
    resultBannerByIdError: ""
}

export const resultBannerSlice = createSlice({
    name: 'resultBanner',
    initialState,
    reducers: {
        getResultBannerListLoading: (state, action) => {
            state.resultBannerListLoading = true
        },
        getResultBannerListSuccess: (state, action) => {
            state.resultBannerListLoading = false
            state.resultBannerList = action.payload
        },

        getResultBannerListError: (state, action) => {
            state.resultBannerListLoading = false
            state.resultBannerList = {}
            state.resultBannerListError = action.payload.message
        },
        getResultBannerByIdLoading: (state, action) => {
            state.resultBannerByIdLoading = true


        },
        getResultBannerByIdSuccess: (state, action) => {
            state.resultBannerByIdLoading = false
            state.resultBannerByIdSuccess = action.payload.data
            state.resultBannerByIdError = ""

        },
        getResultBannerByIdError: (state, action) => {
            state.resultBannerByIdLoading = false
            state.resultBannerByIdSuccess = {}
            state.resultBannerByIdError = action.payload.message


        },
        resetResultBannerDetails: (state, action) => {
            state.resultBannerByIdLoading = false
            state.resultBannerByIdSuccess = {}
        }
    },
})

// Action creators are generated for each case reducer function
export const { getResultBannerListLoading,
    getResultBannerListSuccess,
    getResultBannerListError,
    getResultBannerByIdLoading,
    getResultBannerByIdSuccess,
    getResultBannerByIdError,
    resetResultBannerDetails

} = resultBannerSlice.actions

export default resultBannerSlice.reducer;